export const lazyLoadImages = () => {
  const images = document.querySelectorAll("img[data-src]");
  if (!images.length) return;

  const loadImage = (img) => {
    const picture = img.closest("picture");
    if (picture) {
      picture.querySelectorAll("source[data-srcset]").forEach((source) => {
        source.setAttribute("srcset", source.getAttribute("data-srcset"));
        source.removeAttribute("data-srcset");
      });
    }

    const dataSrc = img.getAttribute("data-src");
    if (dataSrc) {
      img.setAttribute("src", dataSrc);
      img.removeAttribute("data-src");
    }
  };

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadImage(entry.target);
        obs.unobserve(entry.target);
      });
    },
    { rootMargin: "200px" }
  );

  images.forEach((img) => observer.observe(img));
};
